import { render, staticRenderFns } from "./Peer.vue?vue&type=template&id=4781e5b1&"
import script from "./Peer.vue?vue&type=script&lang=js&"
export * from "./Peer.vue?vue&type=script&lang=js&"
import style0 from "./Peer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports